import { FC, memo } from "react";
import cx from "apps/website/utils/misc/cx";

import { Size, sizeClassMap } from "./Spacer.map";

export interface ISpacer {
  /** Predefined spacing size from the design system */
  size?: Size;
  /** Custom spacing value (overrides size) */
  customSize?: string;
  /** Additional CSS classes applied to the spacer */
  className?: string;
}

/**
 * Spacer component
 *
 * A utility component that provides consistent vertical spacing between elements.
 * The Spacer uses predefined spacing tokens that scale responsively across
 * different screen sizes.
 *
 * @param size - Predefined spacing size from the design system
 * @param customSize - Custom spacing value (overrides size)
 * @param className - Additional CSS classes applied to the spacer
 *
 * @example
 * ```tsx
 * <div>Content above</div>
 * <Spacer size="lg" />
 * <div>Content below</div>
 * ```
 *
 * @example
 * ```tsx
 * <Spacer size="xl" className="bg-gray-200" />
 * ```
 */
const Spacer: FC<ISpacer> = ({ size = "xl", className, customSize }) => (
  <div data-component="Spacer" className={cx("block w-full", !customSize ? sizeClassMap[size] : customSize, className)} />
);

export default memo(Spacer);
